import { BigDecimal, Option } from 'effect';

export const bigDecimalToNumberSafe = (bd: BigDecimal.BigDecimal): Option.Option<number> => {
  const num = BigDecimal.toNumberUnsafe(bd);
  if (!Number.isFinite(num)) {
    return Option.none();
  }
  return Option.some(num);
};

export const sqrt = (value: BigDecimal.BigDecimal): Option.Option<BigDecimal.BigDecimal> => {
  const num = BigDecimal.toNumberUnsafe(value);

  if (num < 0 || !Number.isFinite(num)) {
    return Option.none();
  }

  const result = Math.sqrt(num);

  return BigDecimal.fromNumber(result);
};

export const log10 = (value: BigDecimal.BigDecimal): Option.Option<BigDecimal.BigDecimal> => {
  const num = BigDecimal.toNumberUnsafe(value);

  if (num <= 0 || !Number.isFinite(num)) {
    return Option.none();
  }

  const result = Math.log10(num);
  return BigDecimal.fromNumber(result);
};
